export default __webpack_public_path__ + "static/media/down-arrow.9b52668f.svg";